import { render, staticRenderFns } from "./p_card.vue?vue&type=template&id=75fa7334"
import script from "./p_card.vue?vue&type=script&lang=ts"
export * from "./p_card.vue?vue&type=script&lang=ts"
import style0 from "./p_card.vue?vue&type=style&index=0&id=75fa7334&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports